import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Layout from '../../components/layouts/Main';
import AddRoleModal from '../../components/staff/AddRoleModal';
import RoleTabContent from '../../components/staff/RoleTabContent';
import config from '../../config';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

function StaffRoles() {
    const [roles, setRoles] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [activeTab, setActiveTab] = useState(null);
    const sidebarRef = useRef(null);

    const handleRoleClick = (roleId) => {
        setActiveTab(roleId);

        // Remove "show" class only on small screens
        if (window.innerWidth < 576 && sidebarRef.current?.classList.contains('show')) {
            sidebarRef.current.classList.remove('show');
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const [rolesRes, permsRes] = await Promise.all([
            axios.get(`${config.API_BASE_URL}/roles`),
            axios.get(`${config.API_BASE_URL}/permissions`)
        ]);
        setRoles(rolesRes.data);
        setPermissions(permsRes.data);
        if (rolesRes.data.length) setActiveTab(rolesRes.data[0]._id);
    };

    const handleAddRole = async (roleName) => {
        const res = await axios.post(`${config.API_BASE_URL}/roles`, { name: roleName, permissions: [] });
        setRoles([...roles, res.data]);
         toast.success('Role added successfully!');
    };

    const handlePermissionUpdate = async (roleId, updatedPermissions) => {
        await axios.put(`${config.API_BASE_URL}/roles/${roleId}`, { permissions: updatedPermissions });
        fetchData(); 
         toast.success('Permission updated successfully!');
    };

    return (
        <Layout>
            <nav className="mb-3" aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                    <li className="breadcrumb-item active">Staff Roles</li>
                </ol>
            </nav>
            <div className="mb-5">
                <div className="row gx-6 gy-3 mb-4 align-items-center">
                    <div className="col-auto">
                        <h2 className="mb-0">Staff Roles </h2>
                    </div>
                    <div className="col-auto">
                        <AddRoleModal onAdd={handleAddRole} />
                    </div>
                </div>
            </div>
            <div className="chat d-flex phoenix-offcanvas-container pt-1 mt-n1 mb-1">
                <div className="card p-3 p-lg-1 mt-xl-n1 chat-sidebar me-3 phoenix-offcanvas phoenix-offcanvas-start" ref={sidebarRef} id="chat-sidebar">
                    <div className="scrollbar">
                        <div className="tab-content" id="contactListTabContent">
                            <div data-chat-thread-tab-content="data-chat-thread-tab-content">
                                <ul className="nav chat-thread-tab flex-column list">

                                    {roles.map((role) => (
                                        <li className="nav-item read" role="presentation" key={role._id}>
                                            <Link
                                                className={`nav-link d-flex align-items-center justify-content-center p-2 ${activeTab === role._id ? 'active' : ''}`}
                                                data-bs-toggle="tab" data-chat-thread="data-chat-thread"
                                                to={`#tab-thread-${role._id}`} role="tab"
                                                onClick={(e) => {
                                                    e.preventDefault(); // Prevent anchor scroll
                                                    handleRoleClick(role._id);
                                                }}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div className="flex-1">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <h5 className="text-body fw-semibold name text-nowrap">
                                                            {role.name}</h5>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <p className="fs-9 mb-0 line-clamp-1 text-body-tertiary text-opacity-85 message">
                                                            Created At: N/A</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    ))}

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card tab-content flex-1 phoenix-offcanvas-container">

                    {roles.map((role) =>
                        role._id === activeTab ? (
                            <RoleTabContent
                                key={role._id}
                                role={role}
                                permissions={permissions}
                                onUpdate={handlePermissionUpdate}
                            />
                        ) : null
                    )}
                </div>

            </div>
        </Layout>
    );
}

export default StaffRoles;
